import {constants} from '../../constants';

import {TelemetryGenericEnum} from '../../shared/enums';
import {TrackingUtilsService} from './tracking-utils.service';
import {RetrieveAnalyticsServiceValuesInterface} from '../interfaces';
import {AnalyticsService} from '../../modules/core/services/analytics.services';

export const retrieveAnalyticsServiceValuesCase = (
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService,
  loggedInPaxId?: string
): RetrieveAnalyticsServiceValuesInterface => ({
  analyticsData: analyticsService.getAnalyticsDataForTracking(constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN, constants.ANALYTICS_LOCATIONS.READY_TO_BOARD_POP_UP),
  language: trackingUtilsService.getCurrentLanguageCode(),
  brand: trackingUtilsService.getBrandCode(),
  loyaltyNum: loggedInPaxId ? trackingUtilsService.getLoyaltyNum(loggedInPaxId) : TelemetryGenericEnum.EMPTY_VALUE,
  vdsId: trackingUtilsService.getVdsId(),
  platform: trackingUtilsService.getPlatform(),
});
